module.exports = __webpack_public_path__ + "static/media/Letra_Caixa (11).567d8962.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Letra_Caixa/Letra_Caixa (11).jpg
// module id = 333
// module chunks = 0